module.exports = __webpack_public_path__ + "static/img/n2.4faba2a9.jpg";